<template>
  <div>
    <!-- <v-navigation-drawer
      dark
      color="#080679"
      width="75"
      v-model="drawer"
      fixed
      app
    >

      <v-list v-for="(item, index) in menu" :key="index">
        <v-list-item class="px-1">
          <v-card
            width="70"
            height="auto"
            :color="item.link.split('/')[1] === $route.path.split('/')[1] ? '#18005A': 'transparent'"
            flat
            class="cursor-pointer ma-auto pb-2"
            :to="item.link"
          >
            <v-card-title class="justify-center pb-1 pt-3">
              <v-icon
                :color="
                  item.link.split('/')[1] === $route.path.split('/')[1]
                    ? '#ffffff'
                    : '#B2B2B2'
                "
                >{{ item.icon }}</v-icon
              >
            </v-card-title>
            <v-card-text
              class="text-center pa-0"
              style="font-size: 10px; line-height: 1.5;"
              :class="
                item.link.split('/')[1] === $route.path.split('/')[1]
                  ? 'white--text font-weight-bold'
                  : ''
              "
            >
              {{ item.label }}
            </v-card-text>
          </v-card>
        </v-list-item>
      </v-list>
    </v-navigation-drawer> -->
    <v-app-bar
      color="#FFFFFF"
      fixed
      nav
      class="box-shadow"
      app
      style="border-radius: 0px; z-index: 9; height: 68px; ">
      <!-- <v-app-bar-nav-icon class="hidden-lg-and-up" @click.stop="drawer = !drawer"/> -->
      
      <v-toolbar-title 
        class="d-flex align-center">


        <!-- <v-chip
          :color="set_color"
          style="min-width: 120px; height: 43px; border-radius: 50px; justify-content: center">
          <span
            class="body-2 white--text mx-2"
            style="font-weight: 600;">
            {{ user.unit_title }}
          </span>
        </v-chip> -->
        <!-- <router-link to="/profile?menu=profile"> -->
        

        <!-- <v-divider vertical ></v-divider> -->
          
        <v-card flat to="/profile">
          <v-list two-line class="pb-0">
            <v-list-item >
              <v-list-item-avatar class="my-1">
                <v-img :src="company.logo !== undefined && company.logo !== '' ? company.logo : require('@/assets/image/member_default.png')"></v-img>
              </v-list-item-avatar>

              <v-list-item-content>
                <v-list-item-title class="grey--text text--darken-3"><span class="black--text font_weight_600">{{ company.company_name }}</span></v-list-item-title>
                <v-list-item-subtitle class="grey--text">{{ user.name }} ({{ user.cat_title }})</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card>
        <!-- </router-link> -->
        
      </v-toolbar-title>

      <!-- <v-chip
        class="ma-4 white--text px-8 font-weight-medium"
        style="height: 43px; border-radius: 50px;"
        :color="set_color"
        v-if="user.cat_title !== 'Super User'"
      >
        <v-icon left>
          mdi-store
        </v-icon>

        <span
          class="body-2 white--text ml-1"
          style="font-weight: 600;">
          {{ outlet_pick.outlet_name }}
        </span>
      </v-chip> -->

      <v-spacer/>
      <v-card flat to="/dashboard" height="100%" class="d-flex align-center mr-2">
        <div>
          <v-img
            contain
            width="36"
            height="36"
            class="mx-auto my-auto"
            :src="require(`@/assets/icon/home-button.png`)">
          </v-img>
        </div>
      </v-card>
      <v-menu
        offset-y
      >
        <template v-slot:activator="{ attrs, on }">
          <v-btn
            :color="set_color"
            class="white--text text-capitalize"
            v-bind="attrs"
            elevation="0"
            v-on="on"
            width="100px"
            style="border-radius: 10px;"
          >
            Menu
          </v-btn>
        </template>

        <v-list
          nav
          dense
          style="overflow-y: auto; max-height: calc(100vh - 100px);"
        >
        <v-list-item-group
          v-model="selectedItem"
          color="primary"
        >
          <v-list-item :to="'/dashboard'">
            <v-list-item-icon class="mr-2">
              <v-icon color="#1A237E">mdi-home</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>Home</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-divider class=""></v-divider>
        </v-list-item-group>

        <v-list-item class="mb-0">
          <v-list-item-content class="pb-0">
            <v-list-item-title class="black_one font-weight-bold mb-0">Akunting</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
          <v-list-item-group
            v-model="selectedItem"
            color="primary"
          >
            <v-divider class=""></v-divider>
            <v-list-item v-for="(item, index) in menu" :key="index" :to="item.link">
              <v-list-item-icon class="mr-2">
                <v-icon :color="item.color">{{ item.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.label }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- <v-list-item :to="menu[5].link">
              <v-list-item-icon class="mr-2">
                <v-icon color="pink">mdi-currency-usd</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Set Saldo Awal</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="menu[3].link">
              <v-list-item-icon class="mr-2">
                <v-icon color="warning">mdi-file-document-edit-outline</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Jurnal</v-list-item-title>
              </v-list-item-content>
            </v-list-item>


            <v-list-item :to="menu[4].link">
              <v-list-item-icon class="mr-2">
                <v-icon color="success">mdi-book-open-blank-variant</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Buku Besar</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="menu[1].link">
              <v-list-item-icon class="mr-2">
                <v-icon color="accent">mdi-scale-balance</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Neraca</v-list-item-title>
              </v-list-item-content>
            </v-list-item>


            <v-list-item :to="menu[2].link">
              <v-list-item-icon class="mr-2">
                <v-icon color="pink">mdi-chart-bell-curve-cumulative</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Laba Rugi</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="'/trial-balance'">
              <v-list-item-icon class="mr-2">
                <v-icon color="#3E2723">mdi-book-remove</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Tutup Buku</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="`/project`">
              <v-list-item-icon class="mr-2">
                <v-icon color="#00838F">mdi-folder-account</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Project</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="`/divisi`">
              <v-list-item-icon class="mr-2">
                <v-icon color="#BF360C">mdi-bookmark-box</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Divisi</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="`/laporan-sub-keuangan`">
              <v-list-item-icon class="mr-2">
                <v-icon color="#827717">mdi-file-document</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Laporan Sub Keuangan</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="`/audit`">
              <v-list-item-icon class="mr-2">
                <v-icon color="#455A64">mdi-list-box</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Audit</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="`/manage-jurnal`">
              <v-list-item-icon class="mr-2">
                <v-icon color="red">mdi-archive-edit</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Kelola Jurnal</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->


          </v-list-item-group>

          <v-list-item class="mb-0 mt-2">
            <v-list-item-content class="pb-0">
              <v-list-item-title class="black_one font-weight-bold mb-0">Setting</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-list-item-group
            v-model="selectedItem"
            color="primary"
          >
            <v-divider class=""></v-divider>
            <v-list-item v-for="(setting, index) in settings" :key="index" :to="setting.link">
              <v-list-item-icon class="mr-2">
                <v-icon :color="setting.color">{{ setting.icon }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ setting.label }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <!-- <v-list-item :to="'/category-user'">
              <v-list-item-icon class="mr-2">
                <v-icon color="#4A148C">mdi-shape</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Kategori Pegawai</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item :to="'/config'">
              <v-list-item-icon class="mr-2">
                <v-icon color="black">mdi-cog-outline</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Konfigurasi</v-list-item-title>
              </v-list-item-content>
            </v-list-item> -->

            <v-list-item :to="'/profile'">
              <v-list-item-icon class="mr-2">
                <v-icon color="pink">mdi-account</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>Profile</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list-item-group>

          <v-divider class="my-3"></v-divider>
          <v-btn
            :color="set_color"
            outlined
            small
            block
            @click="toLogout()"
            class="text-capitalize"
            elevation="0"
            style="border-radius: 6px;"
            
          >
            Logout
          </v-btn>
        </v-list>

      </v-menu>
      <!-- <div>
        <v-btn
          :color="set_color"
          outlined
          @click="toLogout()"
          class="text-capitalize"
          elevation="0"
          style="border-radius: 10px;"
          
        >
          Logout
        </v-btn>

      </div> -->

    </v-app-bar>

    <!-- <TopBar @drawer-false="drawer = false" /> -->
  </div>
</template>

<script>
// import TopBar from "@/components/TopBar.vue";
import { TokenService } from "@/service/Storage.Service";
import { get, post, put, patch, destroy } from "@/service/Axios";
export default {
  // components: {
  //   TopBar,
  // },
  data() {
    return {
      drawer: true,
      menu: [],
      settings: [],
      manuAll: [],
      selectedItem: 1,
    };
  },

  computed: {
    user() {
      return this.$store.state.user;
    },
    outlet_pick() {
      return this.$store.state.outlet;
    },
    company() {
      return this.$store.state.company;
    },
    token() {
      return this.$store.state.token;
    },
    set_color() {
      return this.$store.state.color;
    },
  },
  mounted() {
    this.manuAll = this.$store.state.menu
    this.menu = []
    this.settings = []
    this.$store.state.menu.map((item) => {
      if (item.label !== 'Pegawai' && item.label !== 'Kategori Pegawai' && item.label !== 'Konfigurasi') {
        this.menu.push(item)
      }
    })

    this.$store.state.menu.map((item) => {
      if (item.label === 'Pegawai' || item.label === 'Kategori Pegawai' || item.label === 'Konfigurasi') {
        this.settings.push(item)
      }
    })

    this.selectedItem = this.manuAll.findIndex(
      (item) => item.link.split("/")[1] === this.$route.path.split("/")[1]
    );
    this.fetch()
  },
  methods: {
    async fetch () {
        await get('config/data')
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            // res.results.data[0].color = JSON.parse(res.results.data[0].color)

            TokenService.saveCompany(JSON.stringify(res.results.data[0]))

            this.$store.commit("setCompany", res.results.data[0])
            
            if (Object.keys(res.results.data[0].color_object).length > 0) {
              // res.results.data[0].color.map((obj) => {
              //   if (obj.active) {
                  TokenService.saveColor(res.results.data[0].color_object.hex)

                  this.$store.commit("setColor", res.results.data[0].color_object.hex)
                  TokenService.saveColor('#080679')

                  // this.$store.commit("setColor", '#080679')
              //   }
              // })
            } else {
              TokenService.saveColor('#080679')

              this.$store.commit("setColor", '#080679')
            }

            this.styles()
          }
        })
      },
      styles () {
        let style = document.createElement('style')
          
        // RESET STYLESHEET TO AUTO
        style.innerHTML = `
          .v-data-table table .v-data-table-header {
            color: white;
            // background-color: ${this.set_color}; !important;
          }
          .v-data-table table > thead > tr > th {
            // background: ${this.set_color};
          }

          .v-data-table table > tbody .v-data-table__selected .v-input--selection-controls__input {
            // color: ${this.set_color};
          }
          .v-data-table table > tbody .v-input--selection-controls__input .v-icon {
            // color: ${this.set_color};
          }

          ::-webkit-scrollbar-thumb{
            border-radius: 10px;
            background-color: ${this.set_color};
          }

          #iw-container .iw-title {
            font-family: 'Open Sans Condensed', sans-serif;
            font-size: 22px;
            font-weight: 400;
            padding: 10px;
            background-color: ${this.set_color};
            color: white;
            margin: 0;
            border-radius: 2px 2px 0 0;
          }

          .v-slide-group__prev .v-icon {
            color: ${this.set_color}; !important;
          }

          .v-slide-group__next .v-icon {
            color: ${this.set_color}; !important;
          }

          .table-grid table > thead > tr > th:nth-child(1) {
            left: 0; 
            z-index: 5;
            // background: ${this.set_color};
          }

          .v-data-table table > tbody > tr:hover .text-start, table > tbody > tr:hover .text-center,  table > tbody > tr:hover .text-end {
            cursor: pointer;
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
            border-radius: 0px !important;
          }
          .v-data-table__selected .text-start, .v-data-table__selected .text-center, .v-data-table__selected .text-end {
            // background-color: ${this.set_color_rgb_up} !important;
            background-color: #E0E0E0 !important;
            border-radius: 0px !important;
          }
        `

        // ADD TO APPENDCHILD
        document.head.appendChild(style)
      },
    toLogout() {
      TokenService.removeToken()
              
      window.location = '/login'
    },
  },
  async toMenu (item) {
        if (item.type === 'logout') {
          TokenService.removeToken()
              
          window.location = '/login'
        } else {
          this.$router.push(item.link)
        }
      },
};
</script>

<style scoped>
.hover-menu:hover,
.actived {
  background: #ffe2ec !important;
}
</style>

<style scoped>
.divider-menu {
  min-height: 50px !important;
  height: 50px;
  width: 26px;
  min-width: 5px;
  margin-top: auto;
  margin-bottom: auto;
  background: #fff;
  border-radius: 10px 0px 0px 10px;
  position: relative;
  right: -11px;
}
</style>

<style>
.v-navigation-drawer__content {
  height: 100%;
  overflow-y: overlay !important;
  overflow-x: hidden;
}
</style>